import classNames from 'classnames';
import React from 'react';
import { BASE_CLASS_NAME } from './constants';

export interface MenuProps extends React.PropsWithChildren<any> {
  id?: string;
  className?: string;
}

const Menu: React.FC<MenuProps> = ({ id, className, children }) => {
  return (
    <div id={id} className={classNames([BASE_CLASS_NAME, className])}>
      {children}
    </div>
  );
};

export default Menu;
